import { Range } from 'types';

export const removeRangeFromRange = (
  rangeToRemove: Range,
  range: Range
): Range[] => {
  const { from, to } = range;
  const { from: removeFrom, to: removeTo, ...rest } = rangeToRemove;

  const result: Range[] = [];

  // Left part before the rangeToRemove
  if (removeFrom > from) {
    result.push({ from, to: removeFrom - 1, ...rest });
  }

  // Right part after the rangeToRemove
  if (removeTo < to) {
    result.push({ from: removeTo + 1, to, ...rest });
  }

  return result;
};
